/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-11
 *
 **/

const alertModule =  {
    namespaced: true,
    state: {
        show: false,
        type: null,
        message: null,
        showLoading: false,
        messageLoading: null,
        redirect: null
    },
    actions: {
        success ({commit}, message){
            commit('hideLoading')
            commit('success', message)
        },
        warning ({commit}, message){
            commit('hideLoading')
            commit('warning', message)
        },
        error ({commit}, message){
            commit('hideLoading')
            commit('error', message)
        },
        clear({commit}) {
            commit('clear')
        },
        showLoading({commit}, message = ''){
            commit('showLoading', message)
        },
        hideLoading({commit}){
            commit('hideLoading')
        },
        redirect({commit}, config){
            commit('redirect', config)
        }
    },
    mutations: {
        success(state, message) {
            state.show = true
            state.type = 'success'
            state.message = message
        },
        warning(state, message) {
            state.show = true
            state.type = 'warning'
            state.message = message
        },
        error(state, message) {
            state.show = true
            state.type = 'error'
            state.message = message
        },
        clear(state){
            state.show = false
            state.type = null
            state.message = null
        },
        showLoading(state, message){
            state.showLoading = true
            state.messageLoading = message
        },
        hideLoading(state){
            state.showLoading = false
            state.messageLoading = null
        },
        redirect(state, config) {
            state.redirect = config
        }
    },
}

export default alertModule